import { findBackendErrorCode, getErrorKind } from '@/shared/lib/errors';

/** Every refusal a Drive route answers with a code; a longer code is listed before any code it starts with. */
export const DRIVE_ERROR_CODES = [
  'DRIVE_FOLDER_PREPARING',
  'DRIVE_UPLOAD_DENIED',
  'DRIVE_UPLOAD_TARGET',
  'DRIVE_UPLOAD_FOLDER_CLOSED',
  'DRIVE_UPLOAD_DECORATION_CLOSED',
  'DRIVE_UPLOAD_NO_ACCESS',
  'DRIVE_UPLOAD_NO_GOOGLE_ACCOUNT',
  'DRIVE_SHARE_INVALID_ADDRESS',
  'DRIVE_SHARE_FOLDER_CLOSED',
  'DRIVE_SHARE_MANAGED_BY_PLATFORM',
  'DRIVE_SHARE_ALREADY_PRESENT',
  'DRIVE_SHARE_REFUSED_BY_GOOGLE',
  'DRIVE_SHARE_EXPIRY_UNSUPPORTED',
  'DRIVE_SHARE_TERMS',
  'DRIVE_SHARE_INHERITED',
  'DRIVE_SHARE_REMOVAL_DENIED',
  'DRIVE_SHARE_NOT_MANUAL',
  'DRIVE_PANEL_DENIED',
  'DRIVE_PLAN_ACCESS_AUTHOR_ONLY',
  'DRIVE_REFRESH_DENIED',
  'DRIVE_REFRESH_TARGET',
  'DRIVE_COPY_DENIED',
  'DRIVE_COPY_SOURCE',
  'DRIVE_COPY_TARGET_CLOSED',
  'PREVIEW_GENERATION_DECORATION_CLOSED',
  'PREVIEW_GENERATION_SOURCES',
  'PREVIEW_GENERATION_GOOGLE_FILES',
  'PREVIEW_GENERATION_IN_FLIGHT',
  'PREVIEW_GENERATION_QUEUE_FULL',
  'ARTWORK_UPLOAD_RETIRED',
] as const;

type Translate = (key: string) => string;

/** A Drive refusal in the person's language when its code is known, else the backend's own words. */
export const resolveDriveError = (error: unknown, t: Translate): string => {
  const { code, raw } = findBackendErrorCode(error, DRIVE_ERROR_CODES);

  return code ? t(`artwork_drive_errors.${code}`) : raw;
};

/** The Drive routes answer 404 when the feature is off for this environment, or the folder does not exist yet. */
export const isDriveUnavailable = (error: unknown): boolean => getErrorKind(error) === 'notFound';
